interface StaticBackgroundProps {
  className?: string;
}

/**
 * Static CSS gradient fallback for devices that don't support WebGL
 * or when effects are disabled. Mimics the caustic color palette
 * with a subtle gradient.
 */
export function StaticBackground({ className }: StaticBackgroundProps) {
  return (
    <div
      className={`${className ?? "pointer-events-none fixed inset-0 z-0"} bg-gradient-warm`}
      aria-hidden="true"
    />
  );
}
